module.exports = __webpack_public_path__ + "img/Cajas_2.e5d0b15a.webp";